import { ActionReducerMap } from "@ngrx/store";
import { assetCreate,openStatusPopUP, assetsetWifi,assetsetApn, assetReboot, assetDelete, assetUpgrade, adminStateReducer,
   telemetryStateReducer, walkTestStartTestReducer, walkTestSettingsReducer,walktestDeviceStatusReducer,
   walktestOngoingTestsReducer,disableButtonReducer,selecMapReducer,reLoadActionsDataReducer,assetPrompt,userReducer,deviceDatailsReducer,gpsReportStateReducer,
   assetadvnceConfig} from "./header.reducer";

interface AppState {
  mapState: '';
  DeploymentState: '';
}

export const reducers: ActionReducerMap<any> = {
    assetCreate: assetCreate,
    openStatusPopUP:openStatusPopUP,
    assetsetWifi: assetsetWifi,
    assetadvnceConfig: assetadvnceConfig,
    assetReboot: assetReboot,
    assetsetApn: assetsetApn,
    assetDelete:assetDelete,
    assetUpgrade:assetUpgrade,
    adminStatus:adminStateReducer,
    telemetryPopup:telemetryStateReducer,
    showStartTest:walkTestStartTestReducer,
    walktestSettings:walkTestSettingsReducer,
    walktestDeviceStatus:walktestDeviceStatusReducer,
    ongoingTests:walktestOngoingTestsReducer,
    disableActions:disableButtonReducer,
    selectedmap:selecMapReducer,
    reloadActions:reLoadActionsDataReducer,
    assetPrompt,
    userReducer,
    deviceDatailsReducer,
    gpsReportStateReducer:gpsReportStateReducer
};